import type { ValidatorFn } from '@angular/forms';
import { Validators } from '@angular/forms';

export const validateEmail = (): ValidatorFn => Validators.pattern(/@[^. ]+\.\S{2,}/);
